const initialState = {
  userData: {},
  courses: [],
  groupTraining: {},
  expertise: [],
  courseBeans: [],
  userDataMap: new Map(),
  userDataList: [],
  courseIdCurrent: null,
  courseNameCurrent: null,
  courseIdSelect: null,
  courseNameSelect: null,
  windowScrollX: 0,
  windowScrollY: 0,
  groupTrainings: null,
  groupTrainingName: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "PROFILE_GET_USER":
      return {
        ...state,
        params: action.params,
        userData: action.data.userData,
        courses: action.data.courses,
      };
    case "PROFILE_GET_GROUP_TRAINING":
      return {
        ...state,
        groupTraining: action.data.groupTraining,
      };
    case "PROFILE_GET_OLD_GROUP_TRAINING":
      return {
        ...state,
        groupTrainings: action.data.groupTrainings,
        groupTrainingName: action.data.groupTrainingName,
      };
    case "PROFILE_GET_EXPERTISE":
      return {
        ...state,
        expertise: action.data.expertise,
      };
    case "PROFILE_DELETE_EXPERTISE":
      return {
        ...state,
        expertise: action.data.expertise,
      };
    case "PROFILE_ADD_EXPERTISE":
      return {
        ...state,
        expertise: action.data.expertise,
      };
    case "PROFILE_GET_COURSE":
      return {
        ...state,
        courseIdSelect: action.data.courseIdCurrent,
        courseIdCurrent: action.data.courseIdCurrent,
        courseBeans: action.data.courseBeans,
        userDataMap: new Map(Object.entries(action.data.userDataMap)),
        userDataList: action.data.userDataListCurrent,
        courseNameSelect: action.data.courseNameCurrent,
        courseNameCurrent: action.data.courseNameCurrent,
      };
    case "PROFILE_SELECT_COURSE":
      return {
        ...state,
        courseIdSelect: action.courseId,
        courseNameSelect: action.courseName,
        userDataList: action.userDataList,
      };
    case "PROFILE_SET_WINDOW_SCROLL":
      return {
        ...state,
        windowScrollX: action.windowScrollX,
        windowScrollY: action.windowScrollY,
      };
    default:
      return state;
  }
};

export default reducer;
